/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Keyword_NewsInputs */



/**
* | output |
* | --- |
* | "News" |
*
* @param {Subtitle_Export_Keyword_NewsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_keyword_news = /** @type {((inputs?: Subtitle_Export_Keyword_NewsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Keyword_NewsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvelles")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nachricht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Notizia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новости")
	if (locale === "es") return /** @type {LocalizedString} */ ("Noticias")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("消息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ニュース")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समाचार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Notícias")
	return /** @type {LocalizedString} */ ("News")
});